/**
 * Converts a string to kebab-case
 *
 * @param {string} string - the input string
 * @returns {string} the output string
 */
export const kebabCase = string =>
  string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()

/**
 * Capitalize the first word of a given word
 *
 * @param {string} str - the input string
 * @returns {string} the updated string
 */
export const capitalizeFirstWord = str => {
  // Check if input is a non-empty string
  if (typeof str !== 'string' || str.length === 0) {
    return ''
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Removes special characters from a string
 *
 * @param {string} inputString - the input string
 * @returns {string} the result
 */
export const removeSpecialCharacters = inputString => {
  const regex = /[^a-zA-Z0-9]/g
  const resultString = inputString.replace(regex, '')

  return resultString
}
